import Vue from 'vue';

export default {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    Vue.nextTick(() => el.focus());
  }
};